<template>
    <table class="table">
        <tbody>
            <tr v-for="(value, key)  in amounts" :v-key="key + value">
                <td>{{key}}</td>
                <td>{{value}}</td>
            </tr>
        </tbody>
    </table>
</template>

<script>
    export default {
        name: "AmountTable",
        props: {
            'amounts': {
                type: Object,   //Technically it's an Amount interface from deployments.ts
                required: true
            }
        }
    }
</script>

<style scoped>

</style>